import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Form from '../../../2_Molecules/Form/Form'
import Input from '../../../1_Atoms/Forms/Input/Input'
import Select from '../../../1_Atoms/Forms/Select/Select'
import { useForm } from '../../../../hooks/useForm'
import { languageController } from '../../../../controllers/language/languageController'
import Button from '../../../1_Atoms/Button/Button'
import { Svg } from '../../../1_Atoms/Svg/Svg'
import { handleRequest } from '../../../../utils/httpRequest'
import { getEndpointUrl } from '../../../../utils/endPoints'
import parse from 'html-react-parser';
import { blockInvalidCharInNumberField } from '../../../../utils/helpers'

function VehicleInformationStep_BaSA({
  handleNextStep,
  topText
}) {
  const [modelData, setModalData] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [modelYearOptions, setModelYearOptions] = useState([]);
  const [isEVSelected, setIsEVSelected] = useState(false);
	const [hasData, setHasData] = useState(false);
  const initState = {
    model: '',
    modelYear: '',
    vin: '',
    kilometers: ''
  }

  const validations = {
    model: ['required'],
    modelYear: ['required'],
    vin: ['vin', 'isAlphaNumeric'],
    kilometers: ['odometer', 'positive'],
  }



  useEffect(() => {
    async function fetchMazdaModels() {
      try {
        const vehiclesDataPath = process.env.REACT_APP_VEHICLES_DATA_PATH || '';

        // Get all the models from a JSON file.
        // With "application/json", axios will automatically try to parse the response into a JavaScript object.
        const modelsData = await handleRequest('get', vehiclesDataPath);

		console.log(typeof modelsData);
        if (typeof modelsData == 'object' && Object.keys(modelsData).length !== 0) {
		  setHasData(true);
          setModalData(modelsData)
          // Set model options with a data-attribute to be attached to option el.
          setModelOptions(Object.keys(modelsData).map(modelName => ({
            value: modelName,
            label: modelName,
            ['data-model-id']: modelName
          })));
        }
      } catch (err) {
        console.log(err)
      }
    }
    // get the model list from the api.
    fetchMazdaModels()
  }, [])

  const { handleSubmit, handleChange, data, errors, setData } = useForm({
    initState,
    validations,
    onSubmit: () => {
      handleNextStep({ vehicleData: { ...data, isEV: isEVSelected } })
    },
  })

  const handleModelYears = (modelId) => {
    if (!modelData) return;
    // Get model data that has the passed model id.
    const modelYearsData = modelData[modelId];

    if (modelYearsData && modelYearsData.years) {
      setModelYearOptions(modelYearsData.years.map(year => ({
        value: year,
        label: year,
        ['data-is-ev']: modelYearsData.ev
      })));
    }
  }

  const { model, modelYear, vin, kilometers } = data;

  return (
    <div className="mz-vehicle-information-step-basa">
      <div className="mz-container">
        <div className="grid-inner-content">
          <div className="mz-vehicle-information-step-basa__top">
            {
              topText && parse(topText)
            }
			{!hasData?
				<div>{languageController.getCopy('bookServiceAppointment', 'carData')}</div>:''
			}
          </div>
          {
            modelOptions.length > 0 && (
              <Form
                onSubmit={handleSubmit}
                isDark={false}
                noValidate={true}
              >
                <Select
                  name="model"
                  label={languageController.getFormCopy('label', 'model')}
                  placeholder={languageController.getFormCopy('placeholder', 'model')}
                  value={model}
                  isRequired={true}
                  errorMessage={errors.model}
                  onChange={(e) => {
                    const { selectedIndex, value } = e.target;
                    // Get model id on the selected option.
                    const modelId = e.target[selectedIndex].getAttribute('data-model-id')
                    setData({ ...data, model: value, modelYear: '' })
                    handleModelYears(modelId)
                  }}
                  options={modelOptions}
                />
                <Select
                  name="modelYear"
                  label={languageController.getFormCopy('label', 'modelYear')}
                  placeholder={languageController.getFormCopy('placeholder', 'modelYear')}
                  value={modelYear}
                  isRequired={true}
                  errorMessage={errors.modelYear}
                  onChange={(e) => {
                    // Get is_ev attr on the selected option.
                    const isEV = e.target[e.target.selectedIndex].getAttribute('data-is-ev');
                    setIsEVSelected((isEV.toLowerCase() === 'true'))
                    handleChange(e)
                  }}
                  options={modelYearOptions}
                  disabled={(!modelYearOptions.length > 0)}
                />
                <Input
                  type="text"
                  name="kilometers"
                  label={languageController.getFormCopy('label', 'kilometers')}
                  value={kilometers}
                  errorMessage={errors.kilometers}
                  onKeyDown={blockInvalidCharInNumberField}
                  onChange={(e) => {
                    // Handle max length
                    if (!isNaN(e.target.value) && e.target.value.length <= 7) {
                      handleChange(e)
                    }
                  }}
                  showOptional={true}
                />
                <Input
                  type="text"
                  name="vin"
                  label={languageController.getFormCopy('label', 'vin')}
                  value={vin}
                  errorMessage={errors.vin}
                  onChange={handleChange}
                  maxLength={17}
                  showOptional={true}
                />
                <Button
                  type="submit"
                  className="mz-btn--primary mz-btn--red"
                  label={languageController.getCopy('global', 'continue')}
                  buttonIcon={<Svg type="chevron_small" size={0.8} colour="white" style={{ top: '1px' }} />}
                  buttonIconPosition="right"
                  disabled={(!modelYear || !model)}
                />
              </Form>
            )
          }
        </div>
      </div>
    </div>
  )
}

VehicleInformationStep_BaSA.propTypes = {
  handleNextStep: PropTypes.func.isRequired
}

export default VehicleInformationStep_BaSA